import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import spin from "../../../assets/icons/spin.png";
import { DEACTIVATED_STATIONS } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import { DeactivatedSitesContainer } from "../components/DeactivatedSitesList";

export const DeactivatedSitesPage = () => {
  const { isLoaded } = useFetchData(DEACTIVATED_STATIONS);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Deactivated Sites" }}
      numberOfData={dataLength}
      bgColor="bg-dBlue-100"
    >
      {isLoaded && !error ? (
        <DeactivatedSitesContainer />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};
